import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";
import { CustomerNotes } from "./GetCustomer";

export async function PostVisitPlan(salesOrg: string, customerNum: string, data: any) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
    },
    data,
    url: `${BASE_URL}/api/customer/visit`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function EditSeasonality(salesOrg: string, customerNum: string, data: any) {
  const config: AxiosRequestConfig = {
    method: "PUT",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
    },
    data,
    url: `${BASE_URL}/api/seasonality/seasonalityUpdate`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function AddSeasonality(salesOrg: string, data: any) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data,
    url: `${BASE_URL}/api/seasonality/seasonalitycustomer`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function DeleteSeasonality(salesOrg: string, columnName: string, customerNum: string) {
  const config: AxiosRequestConfig = {
    method: "DELETE",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      typeOf: columnName,
      id: customerNum,
    },
    url: `${BASE_URL}/api/seasonality/seasonalityCustomer`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function PostNotes(salesOrg: string, customerNum: string, toSave: CustomerNotes[]): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      lang: "EN",
    },
    data: { save: toSave },
    url: `${BASE_URL}/api/customer/notes?customerNum=${customerNum}`,
  };

  //console.log(config)

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function PostRequeueRequest(clientId: string, salesOrg: string, customerNum: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId,
      salesOrg,
      lang: "EN",
    },
    data: {},
    url: `${BASE_URL}/api/customer/requeueSettlement?customerNum=${customerNum}`,
  };

  //console.log(config)

  return AXIOS_INSTANCE(config);
}
